/**
 * Matrix transformation utilities
 */

export function createProjectionMatrix(width, height) {
  const left = -width / 2;
  const right = width / 2;
  const top = height / 2;
  const bottom = -height / 2;
  const near = 0.1;
  const far = 1000;

  return [
    2 / (right - left), 0, 0, 0,
    0, 2 / (top - bottom), 0, 0,
    0, 0, -2 / (far - near), 0,
    -(right + left) / (right - left),
    -(top + bottom) / (top - bottom),
    -(far + near) / (far - near),
    1
  ];
}

export function createModelViewMatrix(rotationX, rotationY, rotationZ, offsetX, offsetY, scale = 1) {
  const z = -200;

  const cosX = Math.cos(rotationX);
  const sinX = Math.sin(rotationX);
  const cosY = Math.cos(rotationY);
  const sinY = Math.sin(rotationY);
  const cosZ = Math.cos(rotationZ);
  const sinZ = Math.sin(rotationZ);

  // Combined rotation matrix (Y * X * Z) with scale
  return [
    (cosY * cosZ - sinY * sinX * sinZ) * scale,
    cosX * sinZ * scale,
    (sinY * cosZ + cosY * sinX * sinZ) * scale,
    0,

    (-cosY * sinZ - sinY * sinX * cosZ) * scale,
    cosX * cosZ * scale,
    (-sinY * sinZ + cosY * sinX * cosZ) * scale,
    0,

    -sinY * cosX * scale,
    -sinX * scale,
    cosY * cosX * scale,
    0,

    offsetX,
    offsetY,
    z,
    1
  ];
}
